import { useQuery, UseQueryOptions } from 'react-query';

import { fetchJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useNotify } from 'app/developer-v3/hooks';

import { IntegrationMaintenanceConfig } from './types';
import { QUERY_KEY_PREFIX } from './constants';
import { formatIntegrationMaintenanceConfig } from './utils';

type Args = {
  integrationId: number;
};

const getQueryKey = (args: Args) => `${QUERY_KEY_PREFIX}-${args.integrationId}`;

export function formatResponseBody(body: any): IntegrationMaintenanceConfig {
  return formatIntegrationMaintenanceConfig(body);
}

function useQueryIntegrationMaintenanceConfig(
  args: Args,
  options?: UseQueryOptions<
    IntegrationMaintenanceConfig,
    Error,
    IntegrationMaintenanceConfig
  >
) {
  const { integrationId } = args;
  const notify = useNotify();

  const queryKey = getQueryKey({ integrationId });
  const url = new URL(
    `api/platform/cli/apps/${encodeURIComponent(
      integrationId
    )}/maintenance-config`,
    ZAPIER_APP_BASE_URL
  );

  const query = useQuery({
    queryKey,
    queryFn: async () => formatResponseBody(await fetchJson(url.href)),
    onError: async (error: any) => notify.failure(error.message, queryKey),
    ...options,
  });

  return { ...query, queryKey };
}

export default useQueryIntegrationMaintenanceConfig;
export { getQueryKey };
